/**
 * 收付款二维码协议（v3.7 + v3.31 商家抵扣）：
 *   meshlink://pay?to=<address>&amount=<dpb>&deduct=<rate>
 *  - 收款：buildPayUri(本人链地址, 可选金额, 可选商家抵扣率) → 渲染二维码
 *  - 付款：parseQrPay(解码文本) → 算账（含 DPB 抵扣）→ wallet.transfer(to, dpb)
 *  - deduct：商家 DPB 抵扣率（0.03–0.30，链上 merchant_deduct_min/max 护栏；
 *            带 deduct 的码即「商家收银台码」，付款方按消费金额算账抵扣）
 */

export interface QrPay {
  /** 收款方链地址（0x + 40 hex，小写）。 */
  to: string;
  /** 期望金额（DPB，可选；缺省 = 任意金额）。 */
  amount?: string;
  /** 商家 DPB 抵扣率（可选；0.03–0.30，存在即商家收银台码）。 */
  deduct?: string;
}

export const PAY_PREFIX = 'meshlink://pay';
const ADDR_RE = /^0x[0-9a-f]{40}$/;

/** 构造收款 URI：meshlink://pay?to=0x…&amount=12.5&deduct=0.2（金额非正数时省略）。 */
export function buildPayUri(to: string, amount?: string, deduct?: string): string {
  const params = new URLSearchParams();
  params.set('to', to.trim().toLowerCase());
  const amt = amount !== undefined && amount.trim() !== '' ? Number(amount) : NaN;
  if (Number.isFinite(amt) && amt > 0) params.set('amount', String(amt));
  const d = deduct !== undefined && deduct.trim() !== '' ? Number(deduct) : NaN;
  if (Number.isFinite(d) && d > 0 && d <= 1) params.set('deduct', String(d));
  return `${PAY_PREFIX}?${params.toString()}`;
}

/** 解析收款 URI；非 pay 协议或地址非法返回 null。 */
export function parseQrPay(text: string): QrPay | null {
  const t = text.trim();
  if (t.toLowerCase().startsWith(PAY_PREFIX) === false) return null;
  const qIdx = t.indexOf('?');
  const params = new URLSearchParams(qIdx >= 0 ? t.slice(qIdx + 1) : '');
  const to = (params.get('to') ?? '').trim().toLowerCase();
  if (!ADDR_RE.test(to)) return null;
  const raw = params.get('amount');
  const amt = raw !== null && raw !== '' ? Number(raw) : NaN;
  const amount = Number.isFinite(amt) && amt > 0 ? String(amt) : undefined;
  const rawD = params.get('deduct');
  const d = rawD !== null && rawD !== '' ? Number(rawD) : NaN;
  const deduct = Number.isFinite(d) && d > 0 && d <= 1 ? String(d) : undefined;
  return { to, amount, deduct };
}
